<template>
  <div>
    <b-row>
      <b-col sm="12" lg="12">
       
          <div v-if="busy" class="d-flex justify-content-center mt-3">
            <b-spinner label="Spinning"></b-spinner>
          </div>
          <el-upload
            class="upload-demo d-inline"
            ref="upload"
            action="string"
            multiple
            :show-file-list="false"
            :before-upload="handleChange"
            :http-request="uploadFiles"
          >
            <b-button @click="documentType = 'public'" class="mb-3 mr-3" size="sm"
              ><b-icon-plus-circle-fill class="mr-2"></b-icon-plus-circle-fill
              >Ajouter un document</b-button
            >
          </el-upload>
          <b-table
            v-if="documents.length > 0 && loaded"
            id="documentsTable"
            striped
            small
            hover
            responsive
            :fields="fields"
            :items="documents"
          >
            <template v-slot:cell(date_encodage)="data">{{
              toDate(data.item.date_encodage)
            }}</template>
            
            <template v-slot:cell(intitule)="data">
              <span>{{ data.item.intitule }}</span>
            </template>
            <template v-slot:cell(note)="data">
              <span v-html="data.item.note"></span>
            </template>
            <template v-slot:cell(document)="data">
              <div
                v-if="data.item.mimeType.indexOf('image') == 0"
              >
              </div>
              <div v-else-if="data.item.mimeType == 'application/pdf'">
                <b-button @click="fullScreen(data.item)" size="sm" class="btn-xs"
                  ><b-icon-search></b-icon-search></b-button
                >
              </div>
              <div v-else>
                <b-button
                  style="font-weight: inherit" size="sm"
                  class="btn-xs"
                  :href="toPath(data.item)"
                  target="_blank"
                  ><b-icon-search></b-icon-search></b-button
                >
              </div>
            </template>
          
          </b-table>
          <b-card-body v-else>
            <b-alert show>Pas de documents</b-alert>
          </b-card-body>
          <b-modal
            size="xl"
            :title="imgFullScreenName"
            id="img-full-screen"
            ok-only
            title-class="text-center"
          >
            <img style="width: 100%" :src="imgFullScreenPath" />
          </b-modal>
          <b-modal
            size="xl"
            :title="objectFullScreenName"
            id="object-full-screen"
            ok-only
            title-class="text-center"
          >
            <object
              style="width: 100%; height: 1000px"
              :data="objectFullScreenPath"
              :type="objectFullScreenMtype"
            >
              <embed
                :src="objectFullScreenPath"
                :type="objectFullScreenMtype"
              />
            </object>
          </b-modal>
         
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import documents from "@/services/documents.js";
import { Upload } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
export default {
  name: "Documents",
  props: {
    id: [Number, String],
    api: String,
    object: String,
  },
  components: {
    [Upload.name]: Upload,
  },
  data() {
    return {
      documents: [],
      currentItem: null,
      busy: false,
      loaded: false,
      imgFullScreenName: null,
      imgFullScreenPath: null,
      objectFullScreenName: null,
      objectFullScreenPath: null,
      objectFullScreenMtype: null,
      documentType: null,
      fields: [
        {
          key: "emittedBy",
          label: "Source",
          sortable: false,
        },
        {
          key: "date_encodage",
          label: "Date",
          sortable: true,
        },
        {
          key: "intitule",
          label: "Nom",
          sortable: false,
        },
        {
          key: "note",
          label: "Note",
          sortable: false,
        },
        {
          key: "document",
          label: "Document",
          sortable: false,
          class: "text-center",
        },
       
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    handleChange(file) {
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$bvToast.toast(
          "Fichier trop lourd! Veillez à ne pas dépasser 100M",
          {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 5000,
            solid: false,
          }
        );
        return false;
      }
    },
    uploadFiles(res) {
      const formData = new FormData();
      formData.append("file", res.file);
      formData.append("type", this.documentType);
      this.busy = true;
      documents.add(this.$props.object, this.$props.id, formData).then(() => {
        this.busy = false;
        this.load();
      });
    },
    load() {
      documents.get(this.$props.object, this.$props.id).then((response) => {
        this.documents = response.data;
        this.loaded = true;
      });
    },
   
    imgClick(item) {
      this.imgFullScreenName = item.intitule;
      this.imgFullScreenPath = this.toPath(item);

      this.$bvModal.show("img-full-screen");
    },
    toPath(item) {
      if (item.path.indexOf("/upload") == 0) {
        // Servi par l'API (document_handler.php), qui exige le jeton : les
        // liens, <img> et <object> n'envoient pas l'en-tête Authorization.
        return (
          this.$store.getters.url +
          item.path +
          "?token=" +
          encodeURIComponent(localStorage.getItem("vue-token"))
        );
      }
      return this.$store.getters.url + "/uploadv2" + item.path;
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    fullScreen(item) {
      this.objectFullScreenName = item.intitule;
      this.objectFullScreenPath = this.toPath(item);
      this.objectFullScreenMtype = item.mimeType;
      this.$bvModal.show("object-full-screen");
    },
  },
};
</script>

<style lang="scss" scoped>
.thumbnail-img {
  img {
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      opacity: 0.7;
    }
  }
}
</style>